// @ts-ignore
import React from 'react';
import { EffectFade, Navigation, Thumbs } from 'swiper';
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation } from 'next-i18next';
import { getDiscount } from '../../../helper';
import Icon from '../../common/Icon';
// eslint-disable-next-line import/named
import { ToLogin } from '../Prices';
import { useMobileSizeDetect } from '../../../src/hooks/useMobileSizeDetect';

export const Subscription = ({
  allPrices,
  setThumbsSwiper,
  isMobileDevice,
  currentSlide,
  slideTo,
  setSwiper,
  navigationPrevRef,
  navigationNextRef,
  setAffiseInfoToStorage,
  BODY,
  authorized,
  ToBuy,
  swiper,
  wrapperClassName,
  setNewLicense,
  textLicenseBuy,
  priceLicenseBuy,
  ulPriceLicenseBuy,
}) => {
  const { t } = useTranslation();
  const isMobileWidth = useMobileSizeDetect(1020);

  return (
    <>
      {/*<div className="ё">{t('prices_welcome_price_tab1_footer')}</div>*/}
      <div className={`r ${wrapperClassName}`}>
        <div className="grid-title">
          <span>{t('prices_full_type')}</span>
        </div>
        {/*{pathname !== '/prices' && (*/}
        {/*  <div className="your-account">*/}
        {/*    <span>{t('checkout_price_header')}</span>*/}
        {/*  </div>*/}
        {/*)}*/}
        <div className="thumbs">
          {allPrices.length && (
            <Swiper
              slidesPerView={allPrices.length}
              onSwiper={setThumbsSwiper}
              allowTouchMove={isMobileDevice}
            >
              {allPrices.map(({ name, value, discount }, index) => (
                <SwiperSlide
                  style={{
                    backgroundColor: currentSlide === index ? 'white' : '#0d0d12',
                    color: currentSlide === index ? '#0d0d12' : 'white',
                  }}
                  key={index}
                  onClick={(event) => {
                    slideTo(event, index);
                    setNewLicense(name);
                  }}
                >
                  {t(`prices_subscription_${name}`)}
                  {!!discount && (
                    <strong>
                      {t('price_save')} {getDiscount(value, discount).save}%
                    </strong>
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>

        <div className="main">
          {allPrices.length && (
            <Swiper
              thumbs={{ swiper }}
              onSwiper={setSwiper}
              modules={[EffectFade, Thumbs, Navigation]}
              slidesPerView={1}
              initialSlide={1}
              effect={!isMobileWidth ? 'fade' : 'flip'}
              navigation={{
                prevEl: navigationPrevRef.current,
                nextEl: navigationNextRef.current,
              }}
            >
              <div className="nav">
                <div className="prev" ref={navigationPrevRef}>
                  <Icon name="20-darr" file="sprite" width="20" height="20" />
                </div>
                <div className="next" ref={navigationNextRef}>
                  <Icon name="20-darr" file="sprite" width="20" height="20" />
                </div>
              </div>
              {allPrices.map(({ currency, id, name, value, discount, type, priceId }) => {
                return (
                  <SwiperSlide key={id}>
                    {({ isActive }) => (
                      <div className="plan">
                        {isActive && setAffiseInfoToStorage(name, value, id)}
                        <div className={`text ${textLicenseBuy}`}>
                          <div className="discount-wrap">
                            {t(`prices_subscription_${name}`)}
                            {!!discount && (
                              <strong>
                                {t('price_save')} {getDiscount(value, discount).save}%
                              </strong>
                            )}
                          </div>
                          <div className="time">{t(`prices_subscription_${name}`)}</div>
                          <div className={`price ${priceLicenseBuy}`}>
                            <div className="big">
                              <sup>{currency}</sup>
                              {new Intl.NumberFormat('ru-RU').format(value)}
                              {!!discount && (
                                <del>
                                  <span>
                                    {currency === '$' && currency}{' '}
                                    {getDiscount(value, discount).formattedPrice}
                                    {currency !== '$' && currency}
                                  </span>
                                </del>
                              )}
                            </div>
                            {/* <div className="small">{description}</div>*/}
                            {!!discount && (
                              <div className="small">
                                {t('price_saving')} {currency}
                                {new Intl.NumberFormat('ru-RU').format(discount)}
                              </div>
                            )}
                          </div>

                          <ul className={ulPriceLicenseBuy}>
                            {BODY.map((i) => (
                              <li key={i}>
                                <Icon width="30" height="30" file="sprite" name="30-success" />
                                {t(`licenceInfo${i}`)}
                              </li>
                            ))}
                          </ul>
                        </div>
                        {authorized ? (
                          <ToBuy name={name} t={t} type={type} priceId={priceId} />
                        ) : (
                          <ToLogin t={t} />
                        )}
                      </div>
                    )}
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}
        </div>
      </div>
    </>
  );
};
